// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_kDv","questions":"styles_questions__182tz","footer":"styles_footer__1Sq0U"};